// This route file is for the B2B admin routes userType = 3
import { lazy } from 'react';
import CBadges from '../container/B2B/CompanyAdmin/Badges/CBadges';
import NewCDashboard from '../container/B2B/CompanyAdmin/Dashboard/NewCDashboard';
import WellbankInvoiceDetails from '../container/Peap/WellBank/PurchaseHistory/InvoiceDetails';
import BTBAddNotification from '../container/PushNotification/BTBAddNotification';
import ViewNotification from '../container/ViewNotification';
import Integrations from '../container/B2B/CompanyAdmin/Integrations/Integrations';
import NotFound from '../container/404NotFound';
import InstantSupportDashboard from '../container/InstantSupport';
import BenefitsDashboard from '../container/Benefits';
import ViewBenefitsPage from '../container/Benefits/ViewBenefits';
import AddCustomBenefitsPage from '../container/Benefits/AddCustomBenefits';
import PulseSurveyDashboard from '../container/PulseSurvey';
import AddEditPulseSurvey from '../container/PulseSurvey/addSurvey/addSurvey';
import PreviewPulseSurveys from '../container/PulseSurvey/preview/preivewPulseSurvey';
import PulseSurvey from '../container/PulseSurvey/pulseSurveyList';
import ContentApproval from '../container/ContentApproval/ContentApproval';
import ViewContentApproval from '../container/ContentApproval/ViewContentApproval';
import ViewSurveyApproval from '../container/ContentApproval/ViewSurveyApproval';
import UnderMaintenance from '../container/userMaintenance';

import AddEditRewards from '../container/B2B/CompanyAdmin/TeamChallanges/AddEditRewards';
import AddEditChallanges from '../container/B2B/CompanyAdmin/TeamChallanges/AddEditChallanges';
import ViewAllChallanges from '../container/B2B/CompanyAdmin/TeamChallanges/ViewAllChallanges';
import ViewAllRewards from '../container/B2B/CompanyAdmin/TeamChallanges/ViewAllRewards';
import AddEditWeeklyChallanges from '../container/B2B/CompanyAdmin/TeamChallanges/AddEditWeeklyChallanges';
import B2BPeapDashboard from '../container/Peap/dashboard/B2BPeapDashboard';
import WellBankDashboard from '../container/Peap/dashboard/WellBankDashboard';
import GetSupport from '../container/InstantSupport/GetSupport';
import InstantSupportCheckoutPage from '../container/InstantSupport/Checkout';
import UpgradeUsersForInstantSupportPage from '../container/InstantSupport/UpgradePlans';
import InstantSupportAddCustomNumber from '../container/InstantSupport/AddCustomNumber';

import TestLandingPage from '../container/TestFeature/index';
import PermissionDenied from '../component/PermissionDenied';
import B2cUsers from '../container/B2B/B2BAdmin/Badges/b2cUsers';
import Challenges from '../container/ChallengesAndTasks/challenges/Challenges';
import NewChallenges from '../container/ChallengesAndTasks/challenges/NewChallenges';
import ViewB2BDetails from '../container/B2B/B2BAdmin/Badges/Components/viewB2BDetails';
import ViewChallenges from '../container/ChallengesAndTasks/challenges/ViewChallenges';
import HealthVideos from '../container/HealthVideos/HealthVideos';
import AllHealthVideos from '../container/HealthVideos/AllHealthVideos';
import ViewHealthVideo from '../container/HealthVideos/ViewHealthVideo';
import { components } from 'react-select';

const Login = lazy(() => import('../container/Login'));
const ForgotPassword = lazy(() => import('../container/ForgotPassword'));
const ResetPassword = lazy(() => import('../container/ResetPassword'));
const ChangePassword = lazy(() => import('../container/ChangePassword'));
const Notification = lazy(() => import('../container/Notification'));
const SubAdmin = lazy(() => import('../container/SubAdmin/SubAdmin'));
const AddEditSubAdmin = lazy(() => import('../container/SubAdmin/AddEditSubAdmin'));
const ViewEditUser = lazy(() => import('../container/Users/ViewEditUser'));

const MyCompany = lazy(() => import('../container/B2B/CompanyAdmin/MyCompany/MyCompany'));
const CompanyUser = lazy(() => import('../container/B2B/CompanyAdmin/CUsers/CUser'));
const CompanyReport = lazy(() => import('../container/B2B/CompanyAdmin/Reports/CReports'));
const CompanySolution = lazy(() => import('../container/B2B/CompanyAdmin/Solution/CSolution'));
const AddUser = lazy(() => import('../container/B2B/CompanyAdmin/CUsers/AddUser'));
// Survey Routes Starts
const AddEditSurvey = lazy(() => import('../container/Survey/AddEditSurvey'));
const PreviewSurvey = lazy(() => import('../container/Survey/PreviewSurvey'));
const MySurvey = lazy(() => import('../container/Survey/MySurvey'));
const MyPulseSurvey = lazy(() => import('../container/PulseSurvey/MyPulseSurvey'));
const SurveyDashboard = lazy(() => import('../container/Survey/SurveyDashboard'));
const SurveyStatistics = lazy(() => import('../container/Survey/SurveyStatistics'));
// Survey Routes Ends

// Peap Routes
const ManageWellPoint = lazy(() =>
  import('../container/Peap/WellBank/ManageWellPoint/ManageWellPoint')
);
const ManageRequest = lazy(() => import('../container/Peap/WellBank/ManageRequest/ManageRequest'));
const PurchaseWellPoint = lazy(() =>
  import('../container/Peap/WellBank/PurchaseWellPoint/PurchaseWellPoint')
);
const BuyNowWellPoint = lazy(() => import('../container/Peap/WellBank/PurchaseWellPoint/BuyNow'));
const BuyNowSummary = lazy(() =>
  import('../container/Peap/WellBank/PurchaseWellPoint/BuyNowSummary')
);
const OrderNowWellPoint = lazy(() =>
  import('../container/Peap/WellBank/PurchaseWellPoint/OrderNow')
);
const OrderNowSummary = lazy(() =>
  import('../container/Peap/WellBank/PurchaseWellPoint/OrderNowSummary')
);
const PurchaseHistory = lazy(() =>
  import('../container/Peap/WellBank/PurchaseHistory/PurchaseHistory')
);
const TransactionHistory = lazy(() =>
  import('../container/Peap/WellBank/TransactionHistory/TransactionHistory')
);
const IndividualDistribution = lazy(() =>
  import('../container/Peap/WellBank/IndividualDistribution/IndividualDistribution')
);
const IndividualAmount = lazy(() =>
  import('../container/Peap/WellBank/IndividualDistribution/IndividualAmount')
);
const EqualAmount = lazy(() =>
  import('../container/Peap/WellBank/IndividualDistribution/EqualAmount')
);
const TeamDistribution = lazy(() =>
  import('../container/Peap/WellBank/TeamDistribution/TeamDistribution')
);
const TeamIndividualAmount = lazy(() =>
  import('../container/Peap/WellBank/TeamDistribution/IndividualAmount')
);
const TeamEqualAmount = lazy(() =>
  import('../container/Peap/WellBank/TeamDistribution/EqualAmount')
);
const CompanyDistribution = lazy(() =>
  import('../container/Peap/WellBank/CompanyDistribution/CompanyDistribution')
);
const AutoWithdrawDistribution = lazy(() =>
  import('../container/Peap/WellBank/AutoWithdrawDistribution/AutoWithdrawDistribution')
);

const routes = [
  {
    path: '/login',
    exact: true,
    name: 'Login',
    component: Login,
    private: false
  },
  {
    path: '/',
    exact: true,
    name: 'Login',
    component: Login,
    private: false
  },
  {
    path: '/forgot-password',
    exact: true,
    name: 'ForgotPassword',
    component: ForgotPassword,
    private: false
  },
  {
    path: '/reset-password',
    exact: true,
    name: 'ResetPassword',
    component: ResetPassword,
    private: false
  },
  {
    path: '/change-password',
    exact: true,
    name: 'ChangePassword',
    component: ChangePassword,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/notifications',
    exact: true,
    name: 'Notification',

    component: ViewNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/users/edit',
    exact: true,
    name: 'ViewEditUser',
    component: ViewEditUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/dashboard',
    exact: true,
    name: 'CompanyDashboard',
    // TODO: Switch
    // component: CompanyDashboard,
    component: NewCDashboard,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/myCompany',
    exact: true,
    name: 'MyCompany',
    component: MyCompany,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/push-notification',
    exact: true,
    name: 'CompanyNotification',
    component: Notification,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },

  {
    path: '/:slug/push-notification/add',
    exact: true,
    name: 'BTBAddPushNotification',
    component: BTBAddNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/health-videos',
    exact: true,
    name: 'healthVideos',
    component: HealthVideos,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/health-videos/all',
    exact: true,
    name: 'allHealthVideos',
    component: AllHealthVideos,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/health-videos/view-health-video',
    exact: true,
    name: 'viewHealthVideo',
    component: ViewHealthVideo,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/report',
    exact: true,
    name: 'CompanyReport',
    component: CompanyReport,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/badges',
    exact: true,
    name: 'CompanyReport',
    // component: BadgeDashboard,
    component: CBadges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/integrations',
    exact: true,
    name: 'Integrations',
    component: Integrations,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/integrations',
    exact: true,
    name: 'Integrations',
    component: Integrations,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/solution',
    exact: true,
    name: 'CompanySolution',
    component: CompanySolution,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/team-challanges',
    exact: true,
    name: 'TeamChallanges',
    // component: ChallangesDashboard,
    component: UnderMaintenance,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/:slug/team-challanges/view-all-challenges',
    exact: true,
    name: 'TeamChallanges',
    component: ViewAllChallanges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/:slug/team-challanges/view-all-rewards',
    exact: true,
    name: 'TeamChallanges',
    component: ViewAllRewards,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/:slug/team-challanges/add-edit-challenges',
    exact: true,
    name: 'TeamChallanges',
    component: AddEditChallanges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/:slug/team-challanges/add-edit-weekly-challenges',
    exact: true,
    name: 'TeamChallanges',
    component: AddEditWeeklyChallanges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/:slug/team-challanges/add-edit-rewards',
    exact: true,
    name: 'TeamChallanges',
    component: AddEditRewards,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/:slug/users',
    exact: true,
    name: 'CompanyUser',
    component: CompanyUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/adduser',
    exact: true,
    name: 'AddUser',
    component: AddUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/users/edituser',
    exact: true,
    name: 'AddUser',
    component: AddUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/notifications',
    exact: true,
    name: 'Notification',
    // component: Notification,
    component: ViewNotification,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },

  {
    path: '/:slug/notifications/view',
    exact: true,
    name: 'Notification',
    component: ViewNotification,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/change-password',
    exact: true,
    name: 'ChangePassword',
    component: ChangePassword,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },

  {
    path: '/:slug/sub-admins',
    exact: true,
    name: 'SubAdmin',
    component: SubAdmin,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/sub-admins/add-edit',
    exact: true,
    name: 'AddEditSubAdmin',
    component: AddEditSubAdmin,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '*',
    exact: true,
    name: 'NotFound',
    component: NotFound,
    private: false
  },
  {
    path: '/users/view',
    exact: true,
    name: 'ViewEditUser',
    component: ViewEditUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  // Survey Routes Starts
  {
    path: '/:slug/surveys/my-survey',
    exact: false,
    name: 'MySurvey',
    component: MySurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/surveys',
    exact: true,
    name: 'Survey Dashboard',
    component: SurveyDashboard,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/surveys/summary/:surveyId',
    exact: false,
    name: 'Survey Summary',
    component: SurveyStatistics,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/surveys/add-edit',
    exact: true,
    name: 'Survey Add Edit',
    component: AddEditSurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/surveys/preview',
    exact: false,
    name: 'Survey Preview',
    component: PreviewSurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/b2b-users',
    exact: true,
    name: 'Badges & Wellpoints',
      component:UnderMaintenance,
   // component: B2cUsers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/challenges',
    exact: true,
    name: 'Challenges',
    component:UnderMaintenance,
   // component: Challenges,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/challenges/create-new-challenges',
    exact: true,
    name: 'Challenges',
    component: NewChallenges,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/challenges/view-challenges',
    exact: true,
    name: 'Challenges',
    component: ViewChallenges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  // instant support screen 1
  {
    path: '/:slug/instant-support',
    exact: true,
    name: 'Instant Support (EAP)',
    component: InstantSupportDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  //Benefits main Screen 1
  {
    path: '/:slug/benefits',
    exact: true,
    name: 'Shoorah Benefits',
    component: UnderMaintenance,
    // component: BenefitsDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // Benefits View Benefits screen 2
  {
    path: '/:slug/benefits/view-benefits',
    exact: true,
    name: 'View Benefits',
    component: ViewBenefitsPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // Benefits Add Benefits screen 2
  {
    path: '/:slug/benefits/add-custom-benefits',
    exact: true,
    name: 'Add Custom Benefits',
    component: AddCustomBenefitsPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // instant support screen 2
  {
    path: '/:slug/instant-support/get-support',
    exact: true,
    name: 'Get Support',
    component: GetSupport,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // instant support screen 3
  {
    path: '/:slug/instant-support/checkout',
    exact: true,
    name: 'Instant Support Checkout',
    component: InstantSupportCheckoutPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // instant support screen 4
  {
    path: '/:slug/instant-support/upgrade-plans',
    exact: true,
    name: 'Instant Support Checkout',
    component: UpgradeUsersForInstantSupportPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // instant support screen 5
  {
    path: '/:slug/instant-support/add-custom-number',
    exact: true,
    name: 'Add Custom Number',
    component: InstantSupportAddCustomNumber,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },

  // test feature B2b Side index.js page route
  {
    path: '/:slug/test',
    exact: true,
    name: 'Test Feature',
    component: UnderMaintenance,
    // component: TestLandingPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/test/create-test',
    exact: true,
    name: 'Create Tests',
    component: UnderMaintenance,
    //component: CreateTestPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // instant support screen 4
  {
    path: '/:slug/instant-support/upgrade-plans',
    exact: true,
    name: 'Instant Support Checkout',
    component: UpgradeUsersForInstantSupportPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // instant support screen 5
  {
    path: '/:slug/instant-support/add-custom-number',
    exact: true,
    name: 'Add Custom Number',
    component: InstantSupportAddCustomNumber,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },

  {
    path: '/:slug/pulse-survey',
    exact: true,
    name: 'pulse survey',
    // component: UnderMaintenance,
    component: PulseSurveyDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/pulse-survey/my-survey',
    exact: true,
    name: 'pulse survey',
    component: MyPulseSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/pulse-survey/add-edit-survey',
    exact: true,
    name: 'addEditSurvey',
    component: AddEditPulseSurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/preview/pulse-surveys',
    exact: false,
    name: 'Pulse Survey Preview',
    component: PreviewPulseSurveys,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/survey-list',
    exact: false,
    name: 'MySurveyList',
    component: PulseSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  // Peap Menu
  {
    path: '/:slug/peap-dashboard',
    exact: true,
    name: "Peap Dashboard",
    // component: B2BPeapDashboard,
    component:UnderMaintenance,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/peap-wellbank',
    exact: true,
    name: "Peap WellBank",
     component:UnderMaintenance,
   // component: WellBankDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/peap-wellbank/manage-wellpoint',
    exact: true,
    name: 'Manage WellPoints',
    component: ManageWellPoint,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/manage-request',
    exact: true,
    name: 'Manage Requests',
    component: ManageRequest,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/purchase-history/:id',
    exact: true,
    name: 'View Previous Invoice',
    component: WellbankInvoiceDetails,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/purchase-wellpoint',
    exact: true,
    name: 'Purchase WellPoints',
    component: PurchaseWellPoint,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/buy-now',
    exact: true,
    name: 'Buy Now Well Points',
    component: BuyNowWellPoint,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/buy-now/summary',
    exact: true,
    name: 'Buy Now Purchase Summary',
    component: BuyNowSummary,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/order-now',
    exact: true,
    name: 'Order Now Well Points',
    component: OrderNowWellPoint,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/order-now/summary',
    exact: true,
    name: 'Order Now Purchase Summary',
    component: OrderNowSummary,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/purchase-history',
    exact: true,
    name: 'Previous Purchase’s',
    component: PurchaseHistory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/transaction-history',
    exact: true,
    name: 'Transaction History',
    component: TransactionHistory,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/individual-distribution',
    exact: true,
    name: 'Individual Distribution',
    component: IndividualDistribution,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/individual-distribution/individual-amount',
    exact: true,
    name: 'Individual Amount',
    component: IndividualAmount,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/individual-distribution/equal-amount',
    exact: true,
    name: 'Equal Amount',
    component: EqualAmount,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/team-distribution',
    exact: true,
    name: 'Team Distribution',
    component: TeamDistribution,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/team-distribution/individual-amount',
    exact: true,
    name: 'Individual Amount',
    component: TeamIndividualAmount,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/team-distribution/equal-amount',
    exact: true,
    name: 'Equal Amount',
    component: TeamEqualAmount,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/company-distribution',
    exact: true,
    name: 'Company Wide Distribution',
    component: CompanyDistribution,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/peap-wellbank/auto-withdraw-distribution',
    exact: true,
    name: 'Auto Withdraw Distribution',
    component: AutoWithdrawDistribution,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/content-approval',
    exact: true,
    name: 'ContentApproval',
    component: ContentApproval,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/content-approval/view',
    exact: true,
    name: 'view-content-approval',
    component: ViewContentApproval,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/view-survey/:surveyId',
    exact: true,
    name: 'view-view-survey',
    component: ViewSurveyApproval,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  }
  // Survey Routes Ends
];
export default routes;
